module.exports = __webpack_public_path__ + "img/img2.b001edd9.png";